import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeModule } from './home/home.module';
import { SharedModule } from '../shared/shared.module';
import { QuienesSomosModule } from './quienes-somos/quienes-somos.module';
import { RouterModule } from '@angular/router';
import { EquipoModule } from './equipo/equipo.module';
import { SalaDePrensaModule } from './sala-de-prensa/sala-de-prensa.module';
import { RetalkModule } from './retalk/retalk.module';
import { CasosExitoModule } from './casos-exito/casos-exito.module';
import { EsgModule } from './esg/esg.module';
import { ContactoModule } from './contacto/contacto.module';
import { LegalModule } from './legal/legal.module';


@NgModule({
  declarations: [

  ],
  imports: [
    CommonModule,
    RouterModule,
    HomeModule,
    SharedModule,
    QuienesSomosModule,
    EquipoModule,
    SalaDePrensaModule,
    RetalkModule,
    CasosExitoModule,
    EsgModule,
    ContactoModule,
    LegalModule
  ],
  exports: [
    HomeModule
  ]
})
export class WwwInfoModule { }
